import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ReviewModeProvider } from './contexts/ReviewModeContext';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Projects } from './pages/Projects';
import { PlantEquipment } from './pages/PlantEquipment';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { NotFound } from './pages/NotFound';
import { CompanyBackground } from './pages/about/CompanyBackground';
import { ManagementTeam } from './pages/about/ManagementTeam';
import { QualityProjectManagement } from './pages/about/QualityProjectManagement';
import { RegistrationsProcurement } from './pages/about/RegistrationsProcurement';
interface AppProps {
  /** Show "For management review" notes on content that needs confirmation. Turn off for launch. */
  showReviewNotes?: boolean;
}
export function App({
  showReviewNotes = true
}: AppProps) {
  return <ReviewModeProvider showReviewNotes={showReviewNotes} data-id="element-0" data-mp="3ijpdn24eb1aa">
      <BrowserRouter data-id="element-1" data-mp="3mkrgdsxitvh0">
        <Routes data-id="element-2" data-mp="3mjzs7369700r">
          <Route element={<Layout data-id="element-4" data-mp="3mj6jhwnqi0fz" />} data-id="element-3" data-mp="3mjg9hk8s47lo">
            <Route index element={<Home data-id="element-6" data-mp="3rdas0kcnegj6" />} data-id="element-5" data-mp="3rbra6pbcfxfa" />
            <Route path="about" element={<Navigate to="/about/company-background" replace data-id="element-8" data-mp="3relwynhtxubv" />} data-id="element-7" data-mp="3rcsuzli5vya7" />
            <Route path="about/company-background" element={<CompanyBackground data-id="element-10" data-mp="2zld2xbxu5jcl" />} data-id="element-9" data-mp="5ghbgghm2z1" />
            <Route path="about/management-team" element={<ManagementTeam data-id="element-12" data-mp="2zng1wlgyumtg" />} data-id="element-11" data-mp="2zmeowbge3q93" />
            <Route path="about/quality-project-management" element={<QualityProjectManagement data-id="element-14" data-mp="33orla998ybt7" />} data-id="element-13" data-mp="33lwyib2rgewm" />
            <Route path="about/registrations-procurement" element={<RegistrationsProcurement data-id="element-16" data-mp="38nulngea7tuu" />} data-id="element-15" data-mp="38li8dgjgy7o4" />
            <Route path="services" element={<Services data-id="element-18" data-mp="3dmfo7mh0apmg" />} data-id="element-17" data-mp="3dl4mds74frxz" />
            <Route path="projects" element={<Projects data-id="element-20" data-mp="nw2bq4xkjoqk" />} data-id="element-19" data-mp="3dii530ufhy2k" />
            <Route path="plant-equipment" element={<PlantEquipment data-id="element-22" data-mp="nxwvvh10nctl" />} data-id="element-21" data-mp="nur8q7by6l0i" />
            <Route path="contact" element={<Contact data-id="element-24" data-mp="st2heeqiaph5" />} data-id="element-23" data-mp="su427axbqqc2" />
            <Route path="privacy-policy" element={<PrivacyPolicy data-id="element-26" data-mp="35ynugqx9fzv" />} data-id="element-25" data-mp="swq9d9gaz3tr" />
            <Route path="*" element={<NotFound data-id="element-28" data-mp="38kv0f9whthk" />} data-id="element-27" data-mp="34x1vh8db93d" />
          </Route>
        </Routes>
      </BrowserRouter>
    </ReviewModeProvider>;
}